import React from 'react';
import { HOW_IT_WORKS } from '@/constants/content';
import { Upload, Cpu, LineChart } from 'lucide-react';

const iconMap = {
  Upload: Upload,
  Cpu: Cpu,
  LineChart: LineChart,
};

export const HowItWorks = () => {
  return (
    <section
      className="py-20 lg:py-32 bg-white"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="how-it-works-title"
          >
            {HOW_IT_WORKS.title}
          </h2>
          <p className="text-lg text-gray-600" data-testid="how-it-works-subtitle">
            {HOW_IT_WORKS.subtitle}
          </p>
        </div>

        {/* Steps */}
        <div className="relative" data-testid="steps-container">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 -translate-y-1/2 z-0" style={{ background: 'linear-gradient(to right, #BFDBFE, #F3E8C6, #BFDBFE)' }}></div>

          <div className="grid md:grid-cols-3 gap-8 lg:gap-12 relative z-10">
            {HOW_IT_WORKS.steps.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <article
                  key={step.step}
                  className="relative bg-white rounded-2xl p-8 border-2 border-gray-200 transition-colors duration-300"
                  onMouseEnter={(e) => e.currentTarget.style.borderColor = '#D7A22F'}
                  onMouseLeave={(e) => e.currentTarget.style.borderColor = '#E5E7EB'}
                  data-testid={`step-${index + 1}`}
                >
                  {/* Step Number */}
                  <div className="absolute -top-6 left-8">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(to bottom right, #D7A22F, #C4911F)' }}>
                      <span
                        className="text-white font-bold text-lg"
                        data-testid={`step-number-${index + 1}`}
                      >
                        {step.step}
                      </span>
                    </div>
                  </div>

                  {/* Icon */}
                  <div className="mb-6 mt-4">
                    <div className="w-16 h-16 rounded-xl flex items-center justify-center" style={{ backgroundColor: '#F3E8C6' }}>
                      <Icon className="w-8 h-8" style={{ color: '#D7A22F' }} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3
                    className="text-xl font-bold text-gray-900 mb-3"
                    style={{ fontFamily: 'Manrope, sans-serif' }}
                    data-testid={`step-title-${index + 1}`}
                  >
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-testid={`step-description-${index + 1}`}>
                    {step.description}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};